import React from 'react';
import styled from 'styled-components';

const ContactBlock = () => {
  return (
    <BlockSection>
      <BlockInner>
        <GoldLine />
        <Title>Ready for your next project?</Title>
        <Subtitle>
          Contact Champion &amp; Champion — we're here to make your vision a reality.
        </Subtitle>
        <SpanishNote>¡Hablamos Español!</SpanishNote>
      </BlockInner>
    </BlockSection>
  );
};

const BlockSection = styled.div`
  background: #f9fafb;
  padding: 56px 32px 48px;
  @media (max-width: 768px) {
    padding: 40px 20px 36px;
  }
`;

const BlockInner = styled.div`
  max-width: 680px;
  margin: 0 auto;
  text-align: center;
`;

const GoldLine = styled.div`
  width: 48px;
  height: 4px;
  background: #c89432;
  border-radius: 2px;
  margin: 0 auto 20px;
`;

const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: clamp(1.3rem, 2.5vw, 1.8rem);
  font-weight: 700;
  color: #111827;
  margin-bottom: 12px;
`;

const Subtitle = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 1rem;
  color: #6b7280;
  line-height: 1.65;
  margin-bottom: 10px;
`;

const SpanishNote = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.9rem;
  color: #c89432;
  font-style: italic;
`;

export default ContactBlock;
